
interface IResult{
    sobrasCredit: number
    co2         : number
}
export class CalcSobransCredit{
    public static calc(availablePortions):IResult {
        let co2            = parseFloat((availablePortions*2.5).toFixed(2));
        let sobrasCredit   = Math.round((co2*2));
        return {
            sobrasCredit: sobrasCredit,
            co2: co2,
        }
    }
}
new CalcSobransCredit();

